<template>
  <v-app-bar class="px-2" :color="bgColor" elevation="0">
    <v-btn
      v-if="props.showBackButton"
      density="compact"
      flat
      :icon="mdiArrowLeft"
      size="default"
      color="on-surface-variant"
      @click="goBack"
    />

    <v-app-bar-title
      class="title font-montserrat font-weight-bold text-center mx-0 text-on-surface-variant"
      :class="padding"
    >
      <slot />
    </v-app-bar-title>

    <v-btn
      v-if="props.showHelpButton"
      class="bg-grey-lighten-3"
      color="primary"
      density="compact"
      elevation="1"
      flat
      :icon="mdiHelp"
      size="default"
      @click="openHelp"
    />
  </v-app-bar>
</template>

<script setup>
  import { useUtils } from "@/composables/useUtils";
  import { useApiStore } from "@/stores/api";
  import { useAppStore } from "@/stores/app";
  import { mdiArrowLeft, mdiHelp } from "@mdi/js";
  import { computed, getCurrentInstance, onMounted, ref } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { useApiClient } from "@/composables/useApiClient";

  const props = defineProps({
    showBackButton: {
      type: Boolean,
      default: true,
    },
    showHelpButton: {
      type: Boolean,
      default: true,
    },
    pathReturn: {
      type: String,
    },
  });

  const emit = defineEmits(["back"]);
  const router = useRouter();
  const route = useRoute();
  const util = useUtils();
  const store = useAppStore();
  const api = useApiStore();
  const apiClient = useApiClient();

  const hasBackEventListener = !!getCurrentInstance()?.vnode.props?.onBack;
  const padding = computed(() => (props.showBackButton ^ props.showHelpButton ? "pe-3" : "px-2"));

  const goBack = async () => {
    if (props.pathReturn && props.pathReturn === "HELP") {
      router.push(window.history.state.back ?? { name: "home" });
      return;
    }
    const result = await api.sequenceScreenFlow(props.pathReturn, false);
    if (result) {
      router.push(result);
    }
  };

  const openHelp = () => {
    router.push({ name: "help" });
  };

  const bgColor = ref("bg-background");

  onMounted(async () => {
    const { data } = await apiClient.getBrandParameters();
    const background = data?.texts;
    if (props.pathReturn === "/terms-of-service") {
      bgColor.value =
        background && background.homeBackgroundImage
          ? background.bgFooter || "transparent"
          : "bg-background";
    }
  });
</script>

<style scoped>
  .title {
    font-size: 1rem;
  }
</style>
